module.exports = __webpack_public_path__ + "static/media/ecommerce.a7e644de.png";